import React from 'react'
import { ReactComponent as Wave } from './../../../assets/wave.svg';
import { Card } from './card';

import styles from './headingCard.module.css';

export const HeadingCard = ({subtitle = '', Icon, children}) => {
    return <Card className={styles.Title}>
        {
            Icon && <div className={styles.Icon}>
                <div className='icon text-color light-stroke'>
                    <Icon />
                </div>
                <hr />
            </div>
        }
        <div>
            <h3>{subtitle}</h3>
            <h1>{children}</h1>
        </div>
        <div className={styles.Wave}>
            <Wave />
        </div>
    </Card>
}